// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import {
  Link as RouterLink,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import CachedIcon from "@mui/icons-material/Cached";
import { v4 as uuidv4 } from "uuid";
import { Portal } from "@mui/base";

// import * as Yup from "yup";
// material
import {
  Card,
  Table,
  Stack,
  // Avatar,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Breadcrumbs,
  Link,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { CallApi } from "../statics.js";
import ClearIcon from "@mui/icons-material/Clear";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  // { id: "title", label: "Title", alignRight: false },
  // { id: "descr", label: "Description", alignRight: false },
  { id: "stepItemTitle", label: "Item Name", alignRight: false },
  { id: "seoTag", label: "SEO Tag", alignRight: false },
  { id: "priority", label: "Priority", alignRight: false },
  { id: "items", label: "Items", alignRight: false },
  { id: "" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ProductStep() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [currentLocItem, setCurrentLocItem] = useState({ title: "" });
  const [actionMode, setActionMode] = useState("accepting");
  const [dialogMode, setDialogMode] = useState("add");
  const [productTitle, setProductTitle] = useState("");
  const [productTitleErrorText, setProductTitleErrorText] = useState("");
  const [productDes, setProductDes] = useState("");
  const [productDesErrorText, setProductDesErrorText] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  // const [addProductLoading, setAddProductLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [seoTag, setSeoTag] = useState("");
  const [priorityValue, setPriorityValue] = useState("");

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("priority");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [priceTypeList, setPriceTypeList] = useState([]);

  const [dimensionTypeList, setDimensionTypeList] = useState([]);
  const [dimensionTypeValue, setDimensionTypeValue] = useState("");
  const [dimensionTypeValueErrorText, setDimensionTypeValueErrorText] =
    useState("");
  const [config, setConfig] = useState(null);
  const [currentProductItem, setCurrentProductItem] = useState({
    id: "",
    title: "",
  });
  const [priceValue, setPriceValue] = useState("");
  const [priceValueErrorText, setPriceValueErrorText] = useState("");
  const [parnetNameList, setParnetNameList] = useState([]);

  const [selectedStepValue, setSelectedStepValue] = useState("");
  const [selectedStepValueErrorText, setSelectedStepValueErrorText] =
    useState("");
  const [selectedStepItemsValue, setSelectedStepItemsValue] = useState([]);
  const [tempSelectedStepItemsValue, setTempSelectedStepItemsValue] = useState(
    []
  );
  const [selectedStepItemsValueErrorText, setSelectedStepItemsValueErrorText] =
    useState("");
  const [stepsList, setStepsList] = useState([]);
  const [stepItemsList, setStepItemsList] = useState([]);
  const [copyToDialog, setCopyToDialog] = useState(false);
  const [copyToPath, setCopyToPath] = useState([]);
  const [allLines, setAllLines] = useState([]);

  const navigate = useNavigate();

  //   let { productId } = useParams();
  let params = useParams();

  // const productTitleTextField = useRef(null);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    getAllLines();
  }, []);

  useEffect(() => {
    if (tableData.length > 0) setDataLoading(false);
  }, [tableData]);

  const findLineStepwithPath = () => {
    let parents = params["*"].split("/");
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      lineId: parents[parents.length - 1],
      parentList: parents,
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("findLineStepwithPath", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setTableData(result.result);
          setParnetNameList(result.parnetNameList);
          setTotalItems(result.paginateInfo.totalItems);
        }

        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) getAllSteps();
  }, [page]);

  const getAllLines = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 100000,
    };
    console.log(data);
    CallApi("getAllLines", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setCopyToPath([{ id: uuidv4(), list: result.result, value: "" }]);
          setAllLines(result.result);
          getAllSteps();
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const getAllSteps = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 100000,
    };
    // console.log(data);
    CallApi("getAllSteps", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setStepsList(result.result);
          findLineStepwithPath();
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const handleFilterByName = (event) => {
  //   setFilterName(event.target.value);
  // };

  // useEffect(() => {
  //   if (addDialogOpen) productTitleTextField.current.focus();
  // }, [addDialogOpen]);

  const handleClickOpen = () => {
    setDialogMode("add");
    // setProductTitle("");
    // setProductTitleErrorText("");
    // setProductDes("");
    // setProductDesErrorText("");
    setSelectedStepItemsValue([]);
    setSelectedStepValue("");
    setSeoTag("");
    setSelectedStepItemsValueErrorText("");
    setSelectedStepValueErrorText("");
    setPriorityValue("");
    setAddDialogOpen(true);
  };

  const addProductItem = () => {
    // if (!productTitle) {
    //   setProductTitleErrorText("Product title cannot be empty");
    //   return;
    // } else {
    //   setProductTitleErrorText("");
    // }

    if (!selectedStepValue) {
      setSelectedStepValueErrorText("Step cannot be empty");
      return;
    } else {
      setSelectedStepValueErrorText("");
    }

    // if (selectedStepItemsValue.length < 1) {
    //   setSelectedStepItemsValue("Step cannot be empty");
    //   return;
    // } else {
    //   setSelectedStepItemsValue("");
    // }

    let parents = params["*"].split("/");
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      lineId: parents[0],
      pic: "",
      stepId: selectedStepValue[0],
      itemIdList: selectedStepItemsValue,
      seoTag1: seoTag ? seoTag : "",
      parentList: parents,
      priority: priorityValue,
    };
    let apiname = "createNewLineStep";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        lineStepId: currentProductItem._id,
        seoTag1: seoTag ? seoTag : "",
        pic: "",
        stepId: selectedStepValue[0],
        itemIdList: selectedStepItemsValue,
        parentList: parents,
        lineId: parents[0],
        priority: priorityValue,
      };
      apiname = "updateLineStep";
    }

    console.log(data);
    setButtonDisabled(true);
    console.log(apiname);
    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            findLineStepwithPath();
            setSnackType("success");

            if (apiname === "createNewLineStep")
              setSnackbarMessage(
                "'" + productTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + productTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      setCurrentProductItem(item);
      setDialogMode("update");
      // setProductTitle(item.title);
      // setProductDes(item.descr);
      setSelectedStepValue([item.stepId]);
      setTempSelectedStepItemsValue([item.itemId]);
      setSeoTag(item.seoTag1 ? item.seoTag1 : "");
      setPriorityValue(
        item.priority || item.priority === 0 ? item.priority : ""
      );
      setPriceValueErrorText("");
      setProductTitleErrorText("");
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentProductItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const onCopyToItem = (item) => {
    if (!buttonDisabled) {
      setCopyToPath([{ id: uuidv4(), list: allLines, value: "" }]);
      setCurrentProductItem(item);
      setCopyToDialog(true);
    }
  };

  const handleChangeDimensionType = (event) => {
    const {
      target: { value },
    } = event;
    setDimensionTypeValue(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeStep = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedStepValue(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeStepItems = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedStepItemsValue(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const findItemswithPath = (path) => {
    // console.log(path);
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      parentList: path,
      page: 0,
      count: 1000,
    };
    // console.log(data);
    // setDataLoading(true);
    CallApi("findItemswithPath", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setStepItemsList(result.result);
          setSelectedStepItemsValue([]);
        }

        // setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  useEffect(() => {
    if (stepItemsList.length > 0 && tempSelectedStepItemsValue.length > 0) {
      setSelectedStepItemsValue(tempSelectedStepItemsValue);
      setTempSelectedStepItemsValue([]);
    }
  }, [stepItemsList]);

  useEffect(() => {
    if (selectedStepValue) findItemswithPath(selectedStepValue);
    else {
      setStepItemsList([]);
      setSelectedStepItemsValue([]);
    }
  }, [selectedStepValue]);

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      lineStepId: currentProductItem._id,
    };

    // console.log(data);

    setButtonDisabled(true);
    CallApi("removeLineStep", "post", data)
      .then((result) => {
        try {
          // console.log(result);
          if (result.status === 200) {
            findLineStepwithPath();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const getBreadcrumbsLink = (id) => {
    let l = "";
    let end = false;
    parnetNameList.forEach((element) => {
      if (!end) l += "/" + element._id;
      if (id === element._id) end = true;
    });

    return l.toString();
  };

  const loadSubCat = () => {
    findLineStepwithPath1();
  };

  const findLineStepwithPath1 = () => {
    let parents = [];

    copyToPath.forEach((element) => {
      parents.push(element.value);
    });

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      lineId: parents[parents.length - 1],
      parentList: parents,
      page: 0,
      count: 1000,
    };
    console.log(data);
    setButtonDisabled(true);
    CallApi("findLineStepwithPath", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          if (result.result.length > 0) {
            let path = JSON.parse(JSON.stringify(copyToPath));
            path.push({ id: uuidv4(), list: result.result, value: "" });
            setCopyToPath(path);
          } else {
            setSnackType("error");
            setSnackbarMessage("there is no product steps");
            setSnackbarOpen(true);
          }
        }
        setButtonDisabled(false);
      } catch (error) {
        console.log("error: ", error);
        setButtonDisabled(false);
      }
    });
  };

  const confirmCopy = () => {
    let i = 0;
    let index = -1;
    let destinationLineStepPath = [];
    copyToPath.forEach((element) => {
      if (!element.value && index === -1) index = i;
      destinationLineStepPath.push(element.value);
      i++;
    });

    if (index > -1) {
      if (index === 0) {
        setSnackType("error");
        setSnackbarMessage("please select destination product");
        setSnackbarOpen(true);
      } else {
        setSnackType("error");
        setSnackbarMessage("please select product step " + index);
        setSnackbarOpen(true);
      }

      return;
    }

    let parents = params["*"].split("/");
    parents.push(currentProductItem._id);
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      originLineId: parents[0],
      destinationLineId: copyToPath[0].value,
      originLineStepPath: "," + parents.toString() + ",",
      destinationLineStepPath: "," + destinationLineStepPath.toString() + ",",
    };

    console.log(data);
    // return;
    setButtonDisabled(true);
    CallApi("copyLineSteps", "post", data)
      .then((result) => {
        setButtonDisabled(false);
        try {
          console.log(result);
          // if (result.status === 200) {
          //   getAllLines();
          // }

          // setCopyToDialog(false);

          setSnackType("success");
          setSnackbarMessage("product successfully copied");
          setSnackbarOpen(true);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Products | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          ></Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          >
            {/* <Typography variant="h4" gutterBottom>
              Product Item of
            </Typography> */}
            <Breadcrumbs aria-label="breadcrumb" mb={2}>
              <Link
                key={-1}
                underline="hover"
                color="inherit"
                href={"/products"}
              >
                Products
              </Link>
              {parnetNameList.map((item, i) => {
                if (i === parnetNameList.length - 1) {
                  return (
                    <Typography key={i} color="text.primary">
                      {item.title}
                    </Typography>
                  );
                } else
                  return (
                    <Link
                      key={i}
                      underline="hover"
                      color="inherit"
                      href={"/products" + getBreadcrumbsLink(item._id)}
                    >
                      {item.title}
                    </Link>
                  );
              })}
            </Breadcrumbs>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Product Step
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        const { _id, stepItemTitle, seoTag1, path } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {stepItemTitle}
                              </Typography>
                            </TableCell>
                            <TableCell>{seoTag1 ? seoTag1 : "-"}</TableCell>
                            {/* <TableCell>{stepItemTitle}</TableCell>
                            <TableCell>{stepTitle}</TableCell> */}
                            <TableCell>
                              {row.priority || row.priority === 0
                                ? row.priority
                                : "-"}
                            </TableCell>
                            <TableCell align="left">
                              <Link
                                href={
                                  "/products" + path.replaceAll(",", "/") + _id
                                }
                              >
                                <Box
                                  component={Icon}
                                  icon={roundAccountTree}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                // hasEdit={false}
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                                onCopyTo={() => onCopyToItem(row)}
                                hasCopyTo
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
          <Dialog
            sx={{ p: 2, mt: 2 }}
            open={deleteDialogOpen}
            TransitionComponent={Transition}
            // keepMounted
            onClose={() => setDeleteDialogOpen(false)}
          >
            <DialogTitle>Deleting Product</DialogTitle>
            <DialogContent sx={{ maxWidth: "400px" }}>
              <DialogContentText id="alert-dialog-description">
                {"Are you sure for deleting '" +
                  currentProductItem.stepItemTitle +
                  "'?"}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={confirmDeleteItem}>Yes</Button>
              <Button
                onClick={() => setDeleteDialogOpen(false)}
                color="secondary"
              >
                No
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            sx={{ p: 2, mt: 2 }}
            open={addDialogOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => {
              if (!buttonDisabled) setAddDialogOpen(false);
            }}
          >
            <DialogTitle>
              {dialogMode === "add"
                ? "Add New Product Step"
                : "Edit Product Step"}
            </DialogTitle>
            <DialogContent sx={{ maxWidth: "400px" }}>
              <FormControl
                sx={{ mb: 2, mt: 1 }}
                fullWidth
                disabled={buttonDisabled}
                error={selectedStepValueErrorText ? true : false}
              >
                <InputLabel>Step</InputLabel>
                <Select
                  IconComponent={() =>
                    selectedStepValue &&
                    selectedStepValue.length > 0 &&
                    dialogMode !== "update" ? (
                      <div
                        style={{
                          marginRight: "10px",
                          padding: "4px",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => setSelectedStepValue("")}
                      >
                        <ClearIcon style={{ fontSize: "20px" }} />
                      </div>
                    ) : null
                  }
                  value={selectedStepValue ? selectedStepValue : ""}
                  onChange={handleChangeStep}
                  input={<OutlinedInput label="Step" />}
                  MenuProps={MenuProps}
                  disabled={buttonDisabled || dialogMode === "update"}
                >
                  {stepsList.map((pt) => (
                    <MenuItem key={pt._id} value={pt._id}>
                      {pt.title}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{selectedStepValueErrorText}</FormHelperText>
              </FormControl>

              {dialogMode !== "update" ? (
                <FormControl
                  sx={{ mb: 2, mt: 1 }}
                  fullWidth
                  error={selectedStepItemsValueErrorText ? true : false}
                  disabled={buttonDisabled || stepItemsList.length < 1}
                >
                  <InputLabel>Step Items</InputLabel>
                  <Select
                    value={selectedStepItemsValue}
                    onChange={handleChangeStepItems}
                    multiple
                    input={<OutlinedInput label="Step Items" />}
                    MenuProps={MenuProps}
                  >
                    {stepItemsList.map((pt) => (
                      <MenuItem key={pt._id} value={pt._id}>
                        {pt.title}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {selectedStepItemsValueErrorText}
                  </FormHelperText>
                </FormControl>
              ) : (
                <FormControl
                  sx={{ mb: 2, mt: 1 }}
                  fullWidth
                  error={selectedStepItemsValueErrorText ? true : false}
                  disabled={buttonDisabled || stepItemsList.length < 1}
                >
                  <InputLabel>Step Items</InputLabel>
                  <Select
                    value={
                      selectedStepItemsValue.length > 0
                        ? selectedStepItemsValue[0]
                        : ""
                    }
                    onChange={handleChangeStepItems}
                    // multiple
                    input={<OutlinedInput label="Step Items" />}
                    MenuProps={MenuProps}
                  >
                    {stepItemsList.map((pt) => (
                      <MenuItem key={pt._id} value={pt._id}>
                        {pt.title}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {selectedStepItemsValueErrorText}
                  </FormHelperText>
                </FormControl>
              )}

              <TextField
                fullWidth
                sx={{ mb: 2 }}
                autoFocus
                type="text"
                label="SEO Tag"
                value={seoTag}
                onChange={(e) => setSeoTag(e.target.value)}
                disabled={buttonDisabled}
              />

              <TextField
                fullWidth
                sx={{ mb: 2 }}
                autoFocus
                type="text"
                label="Priority"
                value={priorityValue}
                onChange={(e) => setPriorityValue(e.target.value)}
                disabled={buttonDisabled}
              />

              {buttonDisabled && (
                <LinearProgress
                  color="primary"
                  sx={{
                    zIndex: "100000",
                    width: "100%",
                    position: "absolute",
                    bottom: "0px",
                    ml: -3,
                  }}
                />
              )}
            </DialogContent>
            <DialogActions sx={{ mb: 1 }}>
              <Button
                onClick={addProductItem}
                variant="contained"
                disabled={buttonDisabled}
              >
                {dialogMode === "add" ? "Add" : "Update"}
              </Button>
              <Button
                onClick={() => setAddDialogOpen(false)}
                color="secondary"
                disabled={buttonDisabled}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      )}

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={copyToDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setCopyToDialog(false);
        }}
      >
        <DialogTitle>Specify the destination path</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          {copyToPath.map((item, i) => {
            return (
              <FormControl
                key={item.id}
                sx={{ mb: 2, mt: 1 }}
                fullWidth
                disabled={buttonDisabled}
                // error={productValueErrorText ? true : false}
              >
                <InputLabel>
                  {i < 1 ? "Product" : "Product Step " + i}
                </InputLabel>
                <Select
                  value={item.value ? item.value : ""}
                  onChange={(e) => {
                    let path = JSON.parse(JSON.stringify(copyToPath));
                    let index = 0;
                    let counter = 0;
                    path.forEach((element) => {
                      if (element.id === item.id) {
                        element.value = e.target.value;
                        index = counter;
                      }
                      counter++;
                    });

                    if (path.length - 1 > index) path.splice(index + 1);

                    setCopyToPath(path);
                  }}
                  input={
                    <OutlinedInput
                      label={i < 1 ? "Product" : "Product Step " + i}
                    />
                  }
                  MenuProps={MenuProps}
                >
                  {item.list.map((pt) => (
                    <MenuItem key={pt._id} value={pt._id}>
                      {i === 0 ? pt.title : pt.stepItemTitle}
                    </MenuItem>
                  ))}
                </Select>
                {/* <FormHelperText>{productValueErrorText}</FormHelperText> */}
              </FormControl>
            );
          })}
          {copyToPath[copyToPath.length - 1]?.value && (
            <Button
              fullWidth
              sx={{ mb: 1 }}
              onClick={loadSubCat}
              variant="outlined"
              disabled={buttonDisabled}
              startIcon={<CachedIcon />}
              component="label"
            >
              Load Product Steps
              {/* <input
              hidden
              accept="image/png,.jpg,.webp"
              // multiple
              type="file"
              onChange={onSelectFileComplete}
              id="selectPicDialog"
            /> */}
            </Button>
          )}

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={confirmCopy}
            variant="contained"
            disabled={buttonDisabled}
          >
            Copy
          </Button>
          <Button
            onClick={() => setCopyToDialog(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
